import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useAISummary } from '@/hooks/ai';
import { useAuth } from '@/contexts/AuthContext';
import { AISummaryPanel } from '@/components/ai';
import { Button } from '@/components/ui/Button';

export function AIAssistantPage() {
  const { id: medicalRecordId } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { user } = useAuth();
  const { mutateAsync: generateSummary, isPending, data: summary } = useAISummary();
  const [error, setError] = useState<string | null>(null);

  const handleGenerate = async () => {
    if (!medicalRecordId || !user?.id) return;
    setError(null);
    try {
      await generateSummary({
        medicalRecordId,
        patientId: user.id,
        doctorId: user.id,
      });
    } catch {
      setError('Erro ao gerar resumo. Tente novamente.');
    }
  };

  return (
    <div className="container max-w-4xl py-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Assistente IA</h1>
        <p className="text-gray-500 mt-1">Geração de resumo clínico inteligente</p>
      </div>

      <div className="mb-6">
        <Button
          onClick={handleGenerate}
          disabled={isPending || !medicalRecordId}
        >
          {isPending ? 'Gerando...' : 'Gerar Resumo Clínico'}
        </Button>
      </div>

      {error && (
        <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-4">
          <p className="text-red-700 text-sm">{error}</p>
        </div>
      )}

      <AISummaryPanel
        summary={summary}
        isLoading={isPending}
        isError={!!error}
      />

      <div className="mt-8">
        <Button variant="outline" onClick={() => navigate(-1)}>
          Voltar
        </Button>
      </div>
    </div>
  );
}
